/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmployeeLocation } from '../../models/employee-location';

export interface GetAllEmployeeLocations$Plain$Params {
}

export function getAllEmployeeLocations$Plain(http: HttpClient, rootUrl: string, params?: GetAllEmployeeLocations$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EmployeeLocation>>> {
  const rb = new RequestBuilder(rootUrl, getAllEmployeeLocations$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EmployeeLocation>>;
    })
  );
}

getAllEmployeeLocations$Plain.PATH = '/api/EmployeeLocation';
